module.exports = "<!-- <router-outlet></router-outlet> -->\n<div (contextmenu)=\"disableRightClick($event)\" (copy)=\"disableCopy($event)\">\n    <router-outlet></router-outlet>\n</div>"


//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main